export { UserNameDisplay } from "./UserNameDisplay";
export type { UserNameDisplayProps } from "./UserNameDisplay";
